module.exports = __webpack_public_path__ + "static/image/service/goods.ver2_0_2.png?67b96e83";